var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLinkButton = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillOpacity: 0.01,
  d: "M0 0h20v20H0z",
  style: {
    mixBlendMode: "multiply"
  }
}), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M7 6.1h10.8v3H7z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M4.15 9h10.7v3H4.15zM2 12h6.1v2.8H2z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m3.113 14.747 5.95-.8L8 15l-.828.747h-4.06zM11 12h2.4v1.5H11zM2.75 10.5h1.5V12h-1.5zM5.45 7.7h2v2h-2zM14.75 9h1.63v1.6h-1.63z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M11 13h1.5v1H11zM12.787 4.33h1.463v1.8H10.5z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M13.35 4.2h4.18v2h-4.18zM8.25 12h3v1.9h-3z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#525252",
  d: "M17.722 4.328a3.495 3.495 0 0 0-4.95 0l.826.827a2.336 2.336 0 0 1 3.303 3.303l-4.66 4.66A2.333 2.333 0 0 1 8.938 9.82l.822-.827-.822-.828-.827.828a3.495 3.495 0 0 0 0 4.95c.66.651 1.55 1.014 2.476 1.008a3.5 3.5 0 0 0 2.487-1.025l4.66-4.66a3.494 3.494 0 0 0-.012-4.939"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#525252",
  d: "M3.125 14.847a2.33 2.33 0 0 1 0-3.302l4.66-4.66a2.33 2.33 0 0 1 3.303 0 2.3 2.3 0 0 1 .664 1.66 2.33 2.33 0 0 1-.682 1.66l-1.235 1.252.828.827 1.234-1.234a3.505 3.505 0 1 0-4.956-4.957l-4.66 4.66a3.495 3.495 0 0 0 0 4.957 3.5 3.5 0 0 0 2.481.99c.934 0 1.83-.368 2.493-1.025l-.827-.828a2.33 2.33 0 0 1-3.303 0"
})));
export default SvgLinkButton;